import React, {
  useMemo,
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
  Accordion,
} from './styles';

import Questions from '../../questions';
import getQuestionAnswer from '../../../../utils/get-question-answer';

const AnswerTranscript = (props) => {
  const {
    surveys,
    testSession,
    onSubmit,
    onCurrentTime,
    onRemoveTagHighlight,
  } = props;

  const ordenedQuestions = useMemo(() => {
    const sessionSurvey = _.find(surveys, { surveyType: 'session' });
    if (!sessionSurvey) {
      return [];
    }
    const { questions } = sessionSurvey;
    const ordered = _.sortBy(questions, 'questionOrder');

    const { testSessionAnswers: answers } = testSession;

    const questionsWithAnswers = ordered.map((q) => ({
      ...q,
      answer: getQuestionAnswer(answers, q && q.id),
    }));

    return questionsWithAnswers;
  }, [surveys, testSession]);

  return (
    <Accordion exclusive={false}>
      {ordenedQuestions && ordenedQuestions.map((question, index) => {
        const { answer } = question;
        if (answer) {
          return (
            <Questions
              key={question.id}
              question={question}
              index={index}
              onCurrentTime={onCurrentTime}
              answer={answer}
              onSubmit={onSubmit}
              onRemoveTagHighlight={(...args) => onRemoveTagHighlight(answer.id, ...args)}
            />
          );
        }
        return null;
      })}
    </Accordion>
  );
};

AnswerTranscript.propTypes = {
  surveys: PropTypes.arrayOf(PropTypes.shape({
    surveyType: PropTypes.string,
  })).isRequired,
  testSession: PropTypes.shape({
    testSessionAnswers: PropTypes.arrayOf(PropTypes.shape({
      videoStartTime: PropTypes.number,
      videoEndTime: PropTypes.number,
    })),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCurrentTime: PropTypes.func.isRequired,
  onRemoveTagHighlight: PropTypes.func.isRequired,
};

export default AnswerTranscript;
